import { setMarkerProperty } from "@/assets/utilities/tinymce/helpers/markerStyle";

const NO_LIST_MESSAGE = "Select one or more list items to set their bullet color.";

const getCurrentListItem = editor => editor.dom.getParent(editor.selection.getNode(), "li");

const getSelectedListItems = editor => {
  const fromBlocks = [
    ...new Set(editor.selection.getSelectedBlocks().map(node => editor.dom.getParent(node, "li")).filter(Boolean)),
  ];

  if (fromBlocks.length) {
    return fromBlocks;
  }

  const current = getCurrentListItem(editor);
  return current ? [current] : [];
};

const notifyIfNoListItems = (editor, items) => {
  if (items.length) {
    return false;
  }

  editor.notificationManager.open({
    text: NO_LIST_MESSAGE,
    type: "info",
    timeout: 3000,
  });
  return true;
};

const setMarkerColor = (editor, items, color) => {
  editor.undoManager.transact(() => {
    items.forEach(li => setMarkerProperty(li, "--marker-color", color));
  });

  editor.fire("change");
};

const openCustomColorPicker = (editor, onChoose) => {
  editor.windowManager.open({
    title: "Color Picker",
    size: "normal",
    body: {
      type: "panel",
      items: [{ type: "colorpicker", name: "colorpicker", label: "Color" }],
    },
    buttons: [
      { type: "cancel", name: "cancel", text: "Cancel" },
      { type: "submit", name: "save", text: "Save", primary: true },
    ],
    onSubmit: api => {
      onChoose(api.getData().colorpicker);
      api.close();
    },
  });
};

const applyFromSwatch = (editor, value) => {
  const items = getSelectedListItems(editor);

  if (notifyIfNoListItems(editor, items)) {
    return;
  }

  if (value === "remove") {
    setMarkerColor(editor, items, "");
    return;
  }

  if (value === "custom") {
    openCustomColorPicker(editor, color => {
      setMarkerColor(editor, items, color);
    });
    return;
  }

  setMarkerColor(editor, items, value);
};

const registerBulletColor = editor => {
  editor.ui.registry.addMenuButton("bulletColor", {
    tooltip: "List bullet/number color",
    icon: "color-picker",
    fetch: callback => {
      callback([
        {
          type: "fancymenuitem",
          fancytype: "colorswatch",
          onAction: data => {
            applyFromSwatch(editor, data.value);
          },
        },
      ]);
    },
  });
};

export { registerBulletColor };
